<span class="site-info-directives" tooltip="{{tooltipMessage}}">
  <i class="fa" [ngClass]="icon"></i> {{ status }}
</span>
